module.exports = __webpack_public_path__ + "1f39e31bc6e80e409485f6c90f049222.pdf";